let configCommon = {
  hotConfigUrl: '/json/externalConfig_cnp.json',
  apiBaseUrl: 'https://cnp-api.clienteswebapp.com'
}

export default configCommon
